import React, { useState } from 'react';
import { FileText, Loader } from 'lucide-react';
import { aiAPI } from '../services/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import StatsAndTabs from './StatsAndTabs';

const ContractReview = ({ onSuccess, stats, loading: statsLoading }) => {
  const [formData, setFormData] = useState({
    contractName: '',
    contractContent: ''
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.contractName.trim() || !formData.contractContent.trim()) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      const response = await aiAPI.reviewContract({
        contractName: formData.contractName,
        contractContent: formData.contractContent
      });

      setResult(response.result);
      toast.success('Contract review completed!');
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Contract review failed:', error);
      toast.error('Failed to review contract');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      contractName: '',
      contractContent: ''
    });
    setResult('');
  };

  return (
    <div>
      <div className="content-header">
        <div className="welcome-section">
          <h2>Contract Review</h2>
          <p>Analyze contracts for risks and improvements with AI</p>
        </div>
      </div>

      <StatsAndTabs stats={stats} loading={statsLoading} />

      <div className="tool-content">
        <div className="tool-header">
          <FileText size={24} />
          <h3>Contract Review</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Contract Name</label>
            <input
              type="text"
              name="contractName"
              className="form-input"
              placeholder="Enter contract name..."
              value={formData.contractName}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contract Content</label>
            <textarea
              name="contractContent"
              className="form-textarea"
              placeholder="Paste your contract content here..."
              value={formData.contractContent}
              onChange={handleChange}
              disabled={loading}
              style={{ minHeight: '200px' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader size={16} className="animate-spin" />
                  Reviewing Contract...
                </>
              ) : (
                <>
                  <FileText size={16} />
                  Review Contract
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {result && (
        <div className="tool-content">
          <div className="tool-header">
            <FileText size={24} />
            <h3>Contract Review Results</h3>
          </div>
          
          <MarkdownRenderer content={result} />

          <div style={{ marginTop: '16px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy Review
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractReview;
